// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FFSi","label":"styles_label__29Npo"};